import React, { Component } from "react";
import { Col, Row } from "react-flexbox-grid";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import AppBar from "@material-ui/core/AppBar";
import Typography from "@material-ui/core/Typography";
import { Formik } from "formik";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { withApollo } from "react-apollo";
import { compose } from "recompose";
import gql from "graphql-tag";
import { Redirect } from "react-router-dom";

const LOGIN = gql`
  mutation($email: EmailAddress!, $password: String!) {
    login(email: $email, password: $password) {
      id
      email
      apiKey
    }
  }
`;

const styles = theme => ({
  box: {
    marginTop: 80
  },
  button: {
    margin: theme.spacing.unit
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit
  }
});

class LoginPage extends Component {
  state = {
    redirectToReferrer: false
  };

  render() {
    const { classes, client, location } = this.props;
    const { from } = location.state || { from: { pathname: "/home" } };
    const { redirectToReferrer } = this.state;

    if (redirectToReferrer === true) {
      return <Redirect to={from} />;
    }
    return (
      <Row className={classes.box}>
        <Col xs={12} sm={6} smOffset={3} md={4} mdOffset={4}>
          <Row>
            <Col xs={12}>
              <AppBar
                style={{ height: 60, padding: 10 }}
                square
                position="static"
              >
                <Typography variant="h6" color="inherit">
                  Iniciar Sesión
                </Typography>
              </AppBar>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <Paper square>
                <Formik
                  initialValues={{ email: "", password: "" }}
                  onSubmit={({ email, password }, { setSubmitting }) => {
                    client
                      .mutate({
                        mutation: LOGIN,
                        variables: { email, password }
                      })
                      .then(response => {
                        localStorage.setItem(
                          "token",
                          response.data.login.apiKey
                        );
                        this.setState(() => ({
                          redirectToReferrer: true
                        }));
                        setSubmitting(false);
                      })
                      .catch(err => {
                        console.log(err);
                        setSubmitting(false);
                      });
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting
                    /* and other goodies */
                  }) => (
                    <form onSubmit={handleSubmit}>
                      <Row>
                        <Col xs style={{ textAlign: "center" }}>
                          <TextField
                            error={errors.email && touched.email}
                            id="email"
                            label="Correo electrónico"
                            name="email"
                            className={classes.textField}
                            margin="normal"
                            variant="outlined"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.email}
                            InputLabelProps={{
                              shrink: true
                            }}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col xs style={{ textAlign: "center" }}>
                          <TextField
                            error={errors.password && touched.password}
                            id="password"
                            label="Contraseña"
                            type="password"
                            name="password"
                            className={classes.textField}
                            margin="normal"
                            variant="outlined"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.password}
                            InputLabelProps={{
                              shrink: true
                            }}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col xs style={{ textAlign: "center" }}>
                          <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                            className={classes.button}
                            disabled={isSubmitting}
                          >
                            Iniciar sesión
                          </Button>
                        </Col>
                      </Row>
                    </form>
                  )}
                </Formik>
              </Paper>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}

export default compose(
  withStyles(styles),
  withApollo
)(LoginPage);



// WEBPACK FOOTER //
// ./src/components/login/index.js